import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 *第三方登录
 */
import { mapActions } from 'vuex';
import { postAction } from '@api/manage';
import { timeFix } from '@/utils/util';
export var JeecgThirdLoginMixin = {
  data: function data() {
    return {
      //第三方登录相关信息
      thirdLoginInfo: '',
      thirdPasswordShow: false,
      thirdLoginPassword: '',
      thirdLoginUser: '',
      thirdConfirmShow: false,
      thirdCreateUserLoding: false,
      thirdLoginState: false,
      //绑定手机号弹窗
      bindingPhoneModal: false,
      thirdPhone: '',
      thirdCaptcha: '',
      //获取验证码按钮30s之内是否可点击
      thirdState: {
        time: 30,
        smsSendBtn: false
      },
      //第三方用户UUID
      thirdUserUuid: '',
      thirdType: '',
      url: {
        bindingThirdPhone: '/sys/thirdLogin/bindingThirdPhone'
      }
    };
  },
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapActions(['ThirdLogin'])), {}, {
    //第三方登录
    onThirdLogin: function onThirdLogin(source) {
      var _this = this;

      var url = window._CONFIG['domianURL'] + "/sys/thirdLogin/render/".concat(source);
      this.openWindowState = window.open(url, "login ".concat(source), 'height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no'); // this.openWindowState.addEventListener("message", (event)=>{
      // 	console.log('event',event)
      // if(event.data.res){
      // 	this.$emit('success',event.data.res)
      // 	this.openWindowState.close()
      // }
      // }, false);
      // this.openWindowState = window.open(url, `login ${source}`, 'height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')
      // window.addEventListener('message',event=>{
      //  console.log('enter')
      //  console.log(event)
      //  if(event.data.res){
      //  this.$emit('success',event.data.res)
      //  this.openWindowState.close()
      //  }
      // },false)

      document.domain = "yesep.online";

      window.changeNav = function (res) {
        _this.$emit('success', res);

        _this.openWindowState.close();
      };

      var that = this;
      that.thirdType = source;
      that.thirdLoginInfo = '';
      that.thirdLoginState = false;

      var receiveMessage = function receiveMessage(event) {
        var token = event.data;

        if (typeof token === 'string') {
          //如果是字符串类型 说明是token信息
          if (token === '登录失败') {
            that.$message.warning(token);
          } else if (token.includes('绑定手机号')) {
            that.bindingPhoneModal = true;
            var strings = token.split(',');
            that.thirdUserUuid = strings[1];
          } else {
            that.doThirdLogin(token);
          }
        } else if (_typeof(token) === 'object') {
          //对象类型 说明需要提示是否绑定现有账号
          if (token['isObj'] === true) {
            that.thirdConfirmShow = true;
            that.thirdLoginInfo = _objectSpread({}, token);
          }
        } else {
          that.$message.warning('不识别的信息传递');
        }
      };

      window.addEventListener('message', receiveMessage, false);
    },
    // 根据token执行登录
    doThirdLogin: function doThirdLogin(token) {
      var _this2 = this;

      if (this.thirdLoginState === false) {
        this.thirdLoginState = true;
        var param = {};
        param.thirdType = this.thirdType;
        param.token = token;
        this.ThirdLogin(param).then(function (res) {
          if (res.success) {
            _this2.loginSuccess();
          } else {
            _this2.requestFailed(res);
          }
        });
      }
    },
    // 绑定已有账号 需要输入密码
    thirdLoginUserBind: function thirdLoginUserBind() {
      this.thirdLoginPassword = '';
      this.thirdLoginUser = this.thirdLoginInfo.uuid;
      this.thirdConfirmShow = false;
      this.thirdPasswordShow = true;
    },
    //创建新账号
    thirdLoginUserCreate: function thirdLoginUserCreate() {
      var _this3 = this;

      this.thirdCreateUserLoding = true; // 账号名后面添加两位随机数

      this.thirdLoginInfo['suffix'] = parseInt(Math.random() * 98 + 1); //this.thirdLoginInfo.operateCode = 123 //测试校验失败

      postAction('/sys/third/user/create', this.thirdLoginInfo).then(function (res) {
        if (res.success) {
          var token = res.result;
          console.log('thirdCreateNewAccount', token);

          _this3.doThirdLogin(token);

          _this3.thirdConfirmShow = false;
        } else {
          _this3.$notification.warning({
            message: res.message
          });
        }
      }).finally(function () {
        _this3.thirdCreateUserLoding = false;
      });
    },
    // 核实密码
    thirdLoginCheckPassword: function thirdLoginCheckPassword() {
      var _this4 = this;

      //this.thirdLoginInfo.operateCode = 123 //测试校验失败
      var param = Object.assign({}, this.thirdLoginInfo, {
        password: this.thirdLoginPassword
      });
      postAction('/sys/third/user/checkPassword', param).then(function (res) {
        if (res.success) {
          _this4.thirdLoginNoPassword();

          _this4.doThirdLogin(res.result);
        } else {
          _this4.$notification.warning({
            message: res.message
          });
        }
      });
    },
    // 没有密码 取消操作
    thirdLoginNoPassword: function thirdLoginNoPassword() {
      this.thirdPasswordShow = false;
      this.thirdLoginPassword = '';
      this.thirdLoginUser = '';
    },
    //获取第三方验证码
    getThirdCaptcha: function getThirdCaptcha() {
      var _this5 = this;

      var that = this;

      if (!this.thirdPhone) {
        that.cmsFailed('请输入手机号');
      } else {
        this.thirdState.smsSendBtn = true;
        var interval = window.setInterval(function () {
          if (that.thirdState.time-- <= 0) {
            that.thirdState.time = 30;
            that.thirdState.smsSendBtn = false;
            window.clearInterval(interval);
          }
        }, 1000);
        var hide = this.$message.loading('验证码发送中..', 0);
        var smsParams = {};
        smsParams.mobile = this.thirdPhone;
        smsParams.smsmode = '1';
        postAction('/sys/sms', smsParams).then(function (res) {
          if (!res.success) {
            setTimeout(hide, 0);

            _this5.cmsFailed(res.message);
          }

          setTimeout(hide, 500);
        }).catch(function (err) {
          setTimeout(hide, 1);
          clearInterval(interval);
          that.thirdState.time = 30;
          that.thirdState.smsSendBtn = false;

          _this5.requestFailed(err);
        });
      }
    },
    //绑定手机号点击确定按钮
    thirdHandleOk: function thirdHandleOk() {
      var _this6 = this;

      var bingingParams = {};
      bingingParams.mobile = this.thirdPhone;
      bingingParams.captcha = this.thirdCaptcha;
      bingingParams.thirdUserUuid = this.thirdUserUuid;
      postAction(this.url.bindingThirdPhone, bingingParams).then(function (res) {
        if (res.success) {
          _this6.bindingPhoneModal = false;

          _this6.doThirdLogin(res.result);
        } else {
          _this6.$notification.warning({
            message: res.message
          });
        }
      });
    },
    loginSuccess: function loginSuccess() {
      // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      // this.loginBtn = false
      // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      this.$router.push({
        path: "/dashboard/analysis"
      }).catch(function () {
        console.log('登录跳转首页出错,这个错误从哪里来的');
      });
      this.$notification.success({
        message: '欢迎',
        description: "".concat(timeFix(), "\uFF0C\u6B22\u8FCE\u56DE\u6765")
      });
    },
    cmsFailed: function cmsFailed(err) {
      this.$notification['error']({
        message: "登录失败",
        description: err,
        duration: 4
      });
    },
    requestFailed: function requestFailed(err) {
      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试",
        duration: 4
      });
      this.loginBtn = false;
    }
  })
};